// PATCH 37 Mi10 — consistent initials avatar for users without a profile photo, both dashboards.
function initials(name, email) {
  const src = (name || "").trim();
  if (src) {
    const parts = src.split(/\s+/);
    return ((parts[0]?.[0] || "") + (parts.length > 1 ? parts[parts.length - 1][0] : "")).toUpperCase();
  }
  return (email || "?").trim()[0]?.toUpperCase() || "?";
}

export default function Avatar({ name, email, size = 30, testid = "avatar" }) {
  return (
    <span className="k-avatar" data-testid={testid} title={name || email || ""}
      style={{ width: size, height: size, fontSize: Math.round(size * 0.4) }} aria-hidden="true">
      {initials(name, email)}
    </span>
  );
}
